import { render, staticRenderFns } from "./V1KodeBarang.vue?vue&type=template&id=74de8199&"
import script from "./V1KodeBarang.vue?vue&type=script&lang=js&"
export * from "./V1KodeBarang.vue?vue&type=script&lang=js&"
import style0 from "./V1KodeBarang.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports